import styles from 'partials/data-table/data-table.module.scss';

export const DataTableHead = ({ children }) => {
	return <div className={styles.header}>{children}</div>;
};
